<template>
  <div>
        <h1>{{tituloh1}}</h1>
        <div class="my-3">
            <b-card>
                <b-form-group
                    class="mb-4"
                    label-cols-lg="3"
                    
                    label-class="font-weight-bold pt-0"
                    label="Empresa"
                    description="">
                    <b-form-radio-group
                        id="radio-firmantemanusa"
                        name="radio-firmantemanusa"
                        v-model="codigoempresa"
                        :options="optEmpresasManusa"
                        stacked
                    ></b-form-radio-group>
                </b-form-group>
            </b-card>
        </div>

        <div class="w-100 d-flex justify-content-between mb-4">            
            <b-button @click="pasoatras" variant="danger">
                <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
                Atrás
            </b-button>
            <b-button :disabled="!sepuedecontinuar" @click="siguientepaso" class="bgcolor-manusa">
                Siguiente
                <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
            </b-button>
        </div>
  </div>
</template>

<script>
    export default {
        props: {
            tituloh1: {
                type: String,
                default: "Selecciona la empresa"
            },
            modalidad: {
                type: String,
                default: "empresas-comites"
            },
        },
        data() {
            return {
                titulo: "",
                codigoempresa: "",
                optEmpresasManusa: []
            }
        },
        mounted () {
            if (this.modalidad==="empresas-comites") {
                this.$store.getters.misEmpresasComitesDeManusa.forEach(e => {
                    this.optEmpresasManusa.push({ "text": e.nombre, "value": e.codigo })
                })  
            } else {
                this.$store.getters.misEmpresasDeManusa.forEach(e => {
                    this.optEmpresasManusa.push({ "text": e.nombre, "value": e.codigo })
                })  
            }          
        },
        methods: {
            siguientepaso() {
                this.$emit('empresa-seleccionada', this.codigoempresa)
            },
            pasoatras() {
                this.$emit('paso-atras')
            },
        },
        computed: {
            sepuedecontinuar() {
                return (this.codigoempresa.length)
            }
        }
    }
</script>